var exports = {
  "YL": "Tooltip.module__tooltip___QTc0Rn",
  "xQ": "Tooltip.module__tooltipPointer___QTc0Rn",
  "rv": "Tooltip.module__tooltipContent___QTc0Rn",
  "iU": "Tooltip.module__tooltipContentLarge___QTc0Rn" + " " + "Tooltip.module__tooltipContent___QTc0Rn",
  "dn": "Tooltip.module__tooltipTop___QTc0Rn",
  "L_": "Tooltip.module__tooltipBottom___QTc0Rn",
  "Lf": "Tooltip.module__tooltipLeft___QTc0Rn",
  "Uu": "Tooltip.module__tooltipRight___QTc0Rn",
  "A4": "Tooltip.module__tooltipPrimary___QTc0Rn",
  "yH": "Tooltip.module__tooltipPointerBg___QTc0Rn",
  "Rp": "Tooltip.module__tooltipRed___QTc0Rn",
  "vX": "Tooltip.module__tooltips___QTc0Rn",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___QTc0Rn",
  "IM": "Tooltip.module__triggerWrapper___QTc0Rn",
};

module.exports = exports;
